import { StatusProps } from '@/models/Status';
import { ApplicationStatus } from './constants';

export const getStatusDescription = (
  statuses: StatusProps[] | null,
  statusId: ApplicationStatus | null,
  localeLanguageCode: string | null
) => {
  if (statuses == null || statusId == null) return null;

  const status = statuses.find((s) => s.id === statusId);
  if (status == null) return null;

  return status.statusDescriptionTranslations[
    localeLanguageCode != null ? localeLanguageCode : 'en'
  ];
};
